export const BB_BETCARD_CSS_CLASS_BLOCK_NAME = 'bb-betcard';
export const BB_BETCARD_CSS_ID_PREFIX = `js-${BB_BETCARD_CSS_CLASS_BLOCK_NAME}`;

export const BB_BETCARD_TICKS_ENDPOINT = '/betfeed_requests/ticks';

export const BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME = `${BB_BETCARD_CSS_CLASS_BLOCK_NAME}__footer`;
export const BB_BETCARD_FOOTER_CSS_CLASS_FEED = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-feed`;
export const BB_BETCARD_FOOTER_CSS_CLASS_TOP = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-top`;
export const BB_BETCARD_FOOTER_CSS_CLASS_HIGHLIGHT = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-highlight`;
export const BB_BETCARD_FOOTER_ICON_CSS_CLASS_BLOCK_NAME = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-icon`;
export const BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER = `${BB_BETCARD_CSS_CLASS_BLOCK_NAME}--color-text-betfeed-number`;

export const BB_BETCARD_MULTI_CSS_CLASS_BLOCK_NAME = `${BB_BETCARD_CSS_CLASS_BLOCK_NAME}__multi`;

export const BB_BETCARD_MUTLI_HEADER_CSS_CLASS_BLOCK_NAME = `${BB_BETCARD_MULTI_CSS_CLASS_BLOCK_NAME}-header`;
export const BB_BETCARD_MUTLI_HEADER_STATUS_CSS_CLASS_NAME = `${BB_BETCARD_MUTLI_HEADER_CSS_CLASS_BLOCK_NAME}-symbol-section`;
export const BB_BETCARD_MUTLI_HEADER_DETAILS_CSS_CLASS_NAME = `${BB_BETCARD_MUTLI_HEADER_CSS_CLASS_BLOCK_NAME}-details-section`;
export const BB_BETCARD_MUTLI_HEADER_BET_BUTTON_CSS_CLASS_NAME = `${BB_BETCARD_MUTLI_HEADER_CSS_CLASS_BLOCK_NAME}-bet-button-section`;
export const BB_BETCARD_MUTLI_HEADER_NUMBER_OF_ACCUMULATORS_CSS_CLASS_NAME = `${BB_BETCARD_MUTLI_HEADER_CSS_CLASS_BLOCK_NAME}-number-of-acca`;

export const BB_BETCARD_MUTLI_HEADER_DETAILS_LISTS_CSS_CLASS_NAME = `${BB_BETCARD_MUTLI_HEADER_DETAILS_CSS_CLASS_NAME}-lists`;

export const BB_ICON_SPORT_SIZE_24 = 'bb-icon bb-icon--sports bb-icon--size-24x24';

export const BB_BETCARD_DROPDOWN_ICON_SIZE = 'size-betcard-dropdown-arrow';

export const BB_BETCARD_GRADIENT_CSS_CLASS_NAME = 'gradient';
export const BB_BETCARD_GRADIENT_CSS_CLASS_NAME_HIDDEN_MODIFIER = `${BB_BETCARD_GRADIENT_CSS_CLASS_NAME}--hidden`;

export const BB_BETCARD_HIGHEST_ODD_VALUE = 999;
export const BB_BETCARD_HIGHEST_ODD_DECIMAL_VALUE = `>${BB_BETCARD_HIGHEST_ODD_VALUE}.99`;
export const BB_BETCARD_HIGHEST_ODD_FRACTION_VALUE = `>${BB_BETCARD_HIGHEST_ODD_VALUE}/1`;
export const BB_BETCARD_HIGHEST_ODD_AMERICAN_VALUE = '>+99999';

export const BB_BETCARD_GA_COMPONENT = 'data-ga_component';
export const BB_BETCARD_GA_UNKNOWN_COMPONENT = 'betcard_ga_component_not_found';
export const I18N_BETCARD = 'betcard';
export const I18N_BETCARD_SELECTIONS = `${I18N_BETCARD}.selections`;
export const I18N_BETCARD_MOST_POPULAR = `${I18N_BETCARD}.most_popular`;
export const I18N_BETCARD_MOST_POPULAR_NAME = `${I18N_BETCARD}.most_popular_name`;
export const I18N_BETCARD_LAST_BET = `${I18N_BETCARD}.last_bet_placed`;
export const I18N_BETCARD_STARTS_IN = `${I18N_BETCARD}.starts_in`;
export const GTM_MULTIPLE_SELECTION = 'multiple';

export const BB_BETCARD_TIMEAGO_OPTIONS = [
    'less_then_min', 'less_then_min', 'one_min', 'x_mins', 'one_hour', 'x_hours',
    'one_day', 'x_days', 'one_week', 'x_weeks', 'one_month', 'x_months', 'one_year',
    'x_years',
];

export const BETCARD_WS_HANDLER_COMPONENT_NAME = 'BetcardClassic';
